import { useMemo } from 'react'

import {
  useAuthenticatedAccount,
  usePermission,
} from 'src/features/auth/context'
import { PERMISSIONS } from 'src/lib/permission'

export const useAccountInfo = () => {
  const { account } = useAuthenticatedAccount()
  const selectedTrial = account.selectedTrial!
  const trialName = selectedTrial.name
  const hospitals = selectedTrial.trialHospitals
  const role = account.member.role
  const { hasPermission } = usePermission()

  const canShowHospitalName = !hasPermission(PERMISSIONS.Hospital_BelongAll)
  const hospital = useMemo(() => {
    if (!canShowHospitalName) {
      return undefined
    }

    return selectedTrial.trialHospitals.find(
      th => th.uid === account.selectedTrialHospitalUid,
    )
  }, [account.selectedTrialHospitalUid, canShowHospitalName, selectedTrial])
  const hospitalName = hospital?.name ?? ''
  const userName = `${account.lastName}${account.firstName}`

  return {
    trialName,
    hospitalName,
    userName,
    role,
    hospitals,
    featureChannel: selectedTrial.featureChannel,
  }
}
